import { ListItem, ListItemText, TextField } from "@mui/material";
import Autocomplete, { AutocompleteProps } from "@mui/material/Autocomplete";
import { makeStyles } from "@mui/styles";
import { SelectOption } from "ds_legacy/components/Select/types";
import { dp, margin } from "ds_legacy/materials/metrics";
import { FONT_SIZE_13 } from "ds_legacy/materials/typography";
import { useState } from "react";
import { useTranslations } from "translations";

export default function SocialWorkerAutoComplete({
  currentValue,
  defaultValue,
  disabled,
  onChange,
  options,
}: Pick<
  AutocompleteProps<SelectOption, false, false, false>,
  "defaultValue" | "disabled" | "options"
> & {
  currentValue: number;
  onChange: (v: SelectOption) => void;
}) {
  const translations = useTranslations();
  const [selectedSocialWorker, setSelectedSocialWorker] =
    useState<SelectOption>(
      options.find(({ id }) => id === currentValue) as SelectOption,
    );

  return (
    <Autocomplete
      autoHighlight
      classes={makeStyles({
        input: {
          fontSize: `${FONT_SIZE_13} !important`,
          minWidth: `${dp(120)} !important`,
        },
        inputRoot: { paddingTop: "0 !important" },
      })()}
      componentsProps={{ paper: { sx: { width: "fit-content" } } }}
      data-testid="social-worker-autocomplete"
      defaultValue={defaultValue || undefined}
      disableClearable
      disabled={disabled}
      id="social-worker-autocomplete"
      isOptionEqualToValue={(option, value) => option.id === value.id}
      options={options}
      renderInput={(params) => (
        <TextField
          placeholder={translations.patient.menuAssigneePlaceholder}
          {...params}
          hiddenLabel
          inputProps={{ ...params.inputProps }}
          variant="standard"
        />
      )}
      renderOption={(props, { id, label }) => {
        const { key, ...optionProps } = props;

        return (
          <ListItem
            key={id || key}
            data-testid={`option-${id}`}
            disablePadding
            divider
            {...optionProps}
          >
            <ListItemText primary={label} />
          </ListItem>
        );
      }}
      sx={{
        "& .MuiAutocomplete-popupIndicator": { padding: 0 },
        marginLeft: margin(1),
        minWidth: "max-content",
      }}
      value={selectedSocialWorker}
      onChange={(e, newValue) => {
        onChange(newValue);
        setSelectedSocialWorker(newValue);
      }}
    />
  );
}
